import { render, staticRenderFns } from "./index2-single.vue?vue&type=template&id=995391c4&scoped=true&"
import script from "./index2-single.vue?vue&type=script&lang=js&"
export * from "./index2-single.vue?vue&type=script&lang=js&"
import style0 from "./index2-single.vue?vue&type=style&index=0&id=995391c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995391c4",
  null
  
)

export default component.exports